import React from 'react'
import { connect } from 'react-redux'
import LoadingIndicator from '@/components/LoadingIndicator'
import { localized } from '@/decorators/localized'
import { TreeView } from '@/components/TreeView'
import { actionCreators } from '@/store/OrganizationalUnits'
import { prepareTreeData } from './OrganizationalUnitTreeView.DataSource'
import { push } from 'react-router-redux'
import { dialogTypes } from '@/dialogs'
import { actionCreators as dialogActions } from '@/store/Dialogs'

@localized()
class OrganizationalUnitTreeView extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      treeData: []
    }
  }

  componentDidMount () {
    const { localize, locale, treeData, units, push, openDialog, create } = this.props
    const data = prepareTreeData({ maximumLevel: 10, tree: treeData }, {
      delete: id => this.props.delete(id),
      detail: id => push(`/organizational-units/${id}`),
      add: (id, item) => openDialog({
        dialogType: dialogTypes.organizationalUnit,
        units: units,
        parent: item,
        onAction: item => create(item, true)
      })
    }, localize, locale)

    this.setState({ treeData: data })
  }

  render () {
    const { rtl, loading } = this.props
    const rowDirection = !rtl ? 'ltr' : 'rtl'
    return (
      <div>{loading
        ? <LoadingIndicator />
        : <TreeView
          className='organizational-structure'
          rowDirection={rowDirection}
          rowHeight={55}
          canDrag={false}
          treeData={this.state.treeData}
          onChange={(tree) => this.setState({ treeData: tree })}
        />}
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    ...state.organizationalUnits,
    ...ownProps
  }
}

const mapDispatchToProps = {
  create: actionCreators.create,
  update: actionCreators.update,
  delete: actionCreators.delete,
  push: push,
  openDialog: dialogActions.openDialog
}

export default connect(mapStateToProps, mapDispatchToProps)(OrganizationalUnitTreeView)



// WEBPACK FOOTER //
// ./src/internal-app/pages/organizationalUnits/treeView/OrganizationalUnitTreeView.js